import React from "react";

import classes from './data_table.module.css';

// TODO: Or just do this inline and get rid of this in general
type Props = { klass?: string, header: React.ReactNode[], rows: React.ReactNode[][] }

// TODO: Any sort or filter... (that could be part of the header definition or better as arrays?)
const DataTable = ({ klass, header, rows }: Props) => {
  return <table className={ `${classes.root} ${klass ?? ''}` }>
    <thead>
      <tr>{ header.map((h,i) => <th key={ i }>{h}</th>)}</tr>
    </thead>
    <tbody>
      { rows.map((r,i) => <tr key={ i }>{ r.map((v,j) => <td key={ j }>{ v }</td> ) }</tr>) }
    </tbody>
  </table>;
}

export default DataTable;
